import { RefObject, useEffect } from 'react';
import c3, { type ChartConfiguration, type ChartAPI } from 'c3';

// Generates a c3 chart on the given ref when `deps` change, destroying any prior chart.
// The factory returns either the c3 config or null to skip rendering. Returns the
// current chart instance to onChart for callers that need to drive it (e.g. brush sync).
export function useC3Chart(
  ref: RefObject<HTMLDivElement | null>,
  configFactory: () => ChartConfiguration | null,
  deps: unknown[],
  onChart?: (chart: ChartAPI) => void
) {
  useEffect(() => {
    if (!ref.current) return;
    const config = configFactory();
    if (!config) return;
    const chart = c3.generate({ ...config, bindto: ref.current });
    onChart?.(chart);
    return () => {
      try { chart.destroy(); } catch (_) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
